import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import HistoryIcon from '@mui/icons-material/History';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AdapterDateFns from '@date-io/date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  Autocomplete,
  Backdrop,
  Badge,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  createTheme,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import {
  DataGridPro,
  GridColDef,
  GridFooter,
  GridFooterContainer,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport
} from '@mui/x-data-grid-pro';
import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'src/appConfig';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetCountriesQuery, useGetSitesQuery, useGetStudiesQuery } from 'src/components/Services/Utils';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSearchHistory } from 'src/store/searchReducer';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { setUserDocPermissions } from 'src/store/User';
import StyledMenu from 'src/theme/StyledTheme';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import CustomNoRowsOverlay from './CustomNoRowsOverlay';
import './searchComponentStyles.scss';
import SearchPreset from './SearchPreset';
import { getPoratlHost } from 'src/components/common/hooks/useUtils';
import { CustomPagination } from 'src/util/DataTableFooter';
import { useSnackbar, VariantType } from 'notistack';
import { Loader } from 'src/components/common/Loader';

const SearchComponent = (props: any) => {
  const [loaderStatus, setLoaderStatus] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [showResult, setShowResult] = useState<boolean>(false);
  const [showSuggestion, setShowSuggestion] = useState<boolean>(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [fromHistory, setFromHistory] = useState<boolean>(false);
  const [searchResultRows, setSearchResultRows] = useState([]);
  const [suggestionResult, setSuggesstionResult] = useState([]);
  const [inputValue, setInputValue] = useState<string>('');
  const searchHistoryStore: any = useSelector((state: AppState) => state.searchDetails.history);
  const [recentHistoryResult, setRecentHistoryResult] = useState<any>(searchHistoryStore ? searchHistoryStore : []);
  const [treeData, setTreeData] = useState<any>([]);
  const [type, setType] = useState<any>([]);
  const [subType, setSubType] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>([]);
  const [enable, setEnable] = useState<boolean>(false);
  const [isSave, setSave] = useState<boolean>();
  const [presetName, setPresetName] = useState<string>('');
  const [badgeCount, setBadgeCount] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [studyList, setStudyList] = useState<any>([]);
  const [siteList, setSiteList] = useState<any>([]);
  const [tmflevels, setTmflevels] = useState<any>([]);
  const [docStatuses, setDocStatuses] = useState<any>([]);
  const [departments, setDepartments] = useState<any>([]);
  const [milestones, setMilestones] = useState<any>([]);
  const [qcIssueTypes, setQcIssueTypes] = useState<any>([]);
  const [certifyRequired, setCertifyRequired] = useState<boolean>(true);
  const [presetSearchData, setPresetSearchData] = useState<any>({});
  const [metaData, setMetaData] = useState<any>({});
  const [operator, setOperator] = useState<string>('equals');
  const [objData, setObjData] = useState<any>('');
  const [presetId, setPresetId] = useState<string>('');
  const { presetFilter, isPreset, isEdit, presetObject, isDeletePreset } = presetSearchData;
  const [isAction, setIsAction] = useState<any>('');
  const [typeVal, setTypeVal] = useState<string | null>('');
  const [inputTypeVal, setInputTypeVal] = useState('');
  const [subTypeVal, setSubTypeVal] = useState<string | null>('');
  const [inputSubTypeVal, setInputSubTypeVal] = useState<string>('');
  const [artifactNameVal, setArtifactNameVal] = useState<string | null>('');
  const [inputArtifactNameVal, setInputArtifactNameVal] = useState<string>('');
  const [docStatusVal, setDocStatusVal] = useState<string>('');
  const docNameInput = useRef<HTMLInputElement>(null);
  const docNoInput = useRef<HTMLInputElement>(null);
  const qcCommentsInput = useRef<HTMLInputElement>(null);
  const [docNameVal, setDocNameVal] = useState<string>('');
  const [docIdVal, setDocIdVal] = useState<string>('');
  const [docLevelVal, setDocLevelVal] = useState<string>('');
  const [docStudyVal, setDocStudyVal] = useState<string>('');
  const [countryVal, setCountryVal] = useState<string>('');
  const [siteVal, setSiteVal] = useState<string>('');
  const [milestoneVal, setMilestoneVal] = useState<string>('');
  const [mileStatusVal, setMileStatusVal] = useState<string>('');
  const [departmentVal, setDepartmentVal] = useState<string>('');
  const [productVal, setProductVal] = useState<string>('');
  const [createdbyVal, setCreatedbyVal] = useState<string>('');
  const [modifiedbyVal, setModifiedbyVal] = useState<string>('');
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const [qcissueVal, setQcissueVal] = useState<string>('');
  const [qccommentVal, setQccommentVal] = useState<string>('');
  const [isClear, setClear] = useState<boolean>(false);
  const [disablePresetSave, setDisablePresetSave] = useState<boolean>(true);
  const [p1Expand, setP1Expand] = useState<boolean>(false);
  const [p2Expand, setP2Expand] = useState<boolean>(false);
  const [p3Expand, setP3Expand] = useState<boolean>(false);
  const [isEditStarted, setIsEditStarted] = useState<boolean>(false);
  const [dataResult, setDataResult] = React.useState<any>([]);
  const [usersList, setUsersList] = useState([]);
  const [userError, setUsersError] = useState(null);
  const [isPresetName, setIsPresetName] = useState<boolean>(false);
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + '' + user.lastName}`;
  const dispatch = useDispatch();
  const docService = new DocManagementService();
  const { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const searchSuggestion = async (searchText: string) => {
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'SearchSuggestions'
    };
    const response: any = await docService.getSearchSuggestions(
      searchText,
      findScope(),
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel,
      params
    );
    setSuggesstionResult(response.data);
    if (response.data === null || response.data.length === 0) {
      setShowSuggestion(false);
    } else {
      setShowSuggestion(true);
    }
  };

  const getAllUsers = async () => {
    const response: any = await docService.getAllUsers(selectedStudy, TmfLevel, '--', selectedCountry, selectedSite);
    if (response?.data) {
      const userData = response?.data.filter((u: any) => u.email !== null);
      setUsersList(userData);
      setUsersError(null);
    } else {
      setUsersError(response?.error);
    }
  };

  const getMasterCodeList = async () => {
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'SearchCodeList'
    };
    const response1: any = await docService.getCodeList(
      'TMFFLVL',
      params,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    setTmflevels(response1.data);
    const response2: any = await docService.getCodeList(
      'TMFSTAT',
      params,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    const filterStatus = response2.data.filter((item: any) => item !== 'Excepted');
    setDocStatuses(filterStatus);
    const response3: any = await docService.getCodeList(
      'TMFDEPT',
      params,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    setDepartments(response3.data);
    const response4: any = await docService.getCodeList(
      'TMFMILS',
      params,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    setMilestones(response4.data);
    const response5: any = await docService.getCodeList(
      'TMFQTYP',
      params,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    setQcIssueTypes(response5.data);
  };

  const handleSearchInputChange = (e: any) => {
    setShowResult(false);
    setInputValue(e.target.value);
    if (e.target.value.length >= 3) {
      setShowHistory(false);
      searchSuggestion(e.target.value);
      setAnchorElSearch(e.currentTarget);
    } else {
      setShowSuggestion(false);
      setAnchorElSearch(null);
    }
  };

  const globalSearch = async (i: any, action = 'click', from: number, size: number) => {
    setAnchorElSearch(null);
    setIsAdvanceSearch(false);
    setIsPresetSearch(false);
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'contentSearch'
    };
    const selectedResult = {
      filter_column: action === 'click' ? suggestionResult[i]['filter_column'] : '*',
      filter_model: action === 'click' ? suggestionResult[i]['filter_model'] : '',
      actual_value: action === 'click' ? suggestionResult[i]['actual_value'] : inputValue,
      occurrences: action === 'click' ? suggestionResult[i]['occurrences'] : 0
    };
    let updatedRecentHistoryResults: any = [];
    if (recentHistoryResult.length > 0) {
      const obj = recentHistoryResult.find((o: any, i: number) => {
        if (o.actual_value === selectedResult.actual_value && o.filter_column === selectedResult.filter_column) {
          updatedRecentHistoryResults = [...recentHistoryResult];
          updatedRecentHistoryResults.splice(i, 1);
          updatedRecentHistoryResults.unshift(selectedResult);
          setRecentHistoryResult(updatedRecentHistoryResults);
          return true;
        } else {
          updatedRecentHistoryResults = [selectedResult, ...recentHistoryResult];
          setRecentHistoryResult(updatedRecentHistoryResults);
        }
      });
    } else {
      updatedRecentHistoryResults = [selectedResult, ...recentHistoryResult];
      setRecentHistoryResult(updatedRecentHistoryResults);
    }

    action === 'click' ? setInputValue(selectedResult['actual_value']) : setInputValue(inputValue);
    const dataObj = {
      query_filters: [
        {
          name: action === 'click' ? selectedResult['filter_column'] : inputValue !== '' ? '*' : '',
          value: action === 'click' ? selectedResult['actual_value'] : inputValue,
          operation: action === 'click' ? operator : 'contains'
        }
      ],
      filter_types: findScope()
    };
    setSearchHistory(dispatch, {
      history: updatedRecentHistoryResults
    });
    setObjData(i);
    setIsAction(action);
    const response: any = await docService.getGlobalSearch(dataObj, null, null, null, 'None', params, from, size);

    if (response.data) {
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } else {
      setSearchResultRows([]);
      setRowCount(0);
    }
  };

  const handleAdvFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsEditStarted(true);
    if (e.target.name === 'tmf_doc_status') setDocStatusVal(e.target.value);
    if (e.target.name === 'tmf_document_name') setDocNameVal(e.target.value);
    if (e.target.name === 'tmf_document_id') setDocIdVal(e.target.value);
    if (e.target.name === 'tmf_doc_level') setDocLevelVal(e.target.value);
    if (e.target.name === 'tmf_doc_study') setDocStudyVal(e.target.value);
    if (e.target.name === 'tmf_doc_country') setCountryVal(e.target.value);
    if (e.target.name === 'tmf_doc_site') setSiteVal(e.target.value);
    if (e.target.name === 'tmf_doc_milestone') setMilestoneVal(e.target.value);
    if (e.target.name === 'tmf_doc_milestone_status') setMileStatusVal(e.target.value);
    if (e.target.name === 'tmf_doc_viewer_department') setDepartmentVal(e.target.value);
    if (e.target.name === 'tmf_doc_viewer_product_detail') setProductVal(e.target.value);
    if (e.target.name === 'tmf_doc_created_by') setCreatedbyVal(e.target.value);
    if (e.target.name === 'tmf_doc_last_modified_by') setModifiedbyVal(e.target.value);
    if (e.target.name === 'tmf_doc_viewer_qc_issue_type') setQcissueVal(e.target.value);
    if (e.target.name === 'tmf_doc_viewer_qc_issue_comments') setQccommentVal(e.target.value);
  };

  const cbxCertifyClick = async (e: any) => {
    setIsEditStarted(true);
    if (!e.target.checked) {
      setCertifyRequired(false);
    } else {
      setCertifyRequired(true);
    }
  };

  const qf: any = [];
  const buildPayload = () => {
    if (typeVal !== '' && typeVal !== null) qf.push({ name: 'tmf_doc_type', value: typeVal, operation: 'equals' });
    if (subTypeVal !== '' && subTypeVal !== null)
      qf.push({ name: 'tmf_doc_subtype', value: subTypeVal, operation: 'equals' });
    if (artifactNameVal !== '' && artifactNameVal !== null)
      qf.push({ name: 'tmf_artifact_name', value: artifactNameVal, operation: 'equals' });
    if (docStatusVal !== '') qf.push({ name: 'tmf_doc_status', value: docStatusVal, operation: 'equals' });
    if (docNameVal !== '')
      qf.push({ name: 'tmf_document_name', value: docNameVal, operation: 'case_insensitive_like' });
    if (docIdVal !== '') qf.push({ name: 'tmf_document_id', value: docIdVal, operation: 'case_insensitive_like' });
    if (docLevelVal !== '') qf.push({ name: 'tmf_doc_level', value: docLevelVal, operation: 'equals' });
    if (docStudyVal !== '') qf.push({ name: 'tmf_doc_study', value: docStudyVal, operation: 'equals' });
    if (countryVal !== '') qf.push({ name: 'tmf_doc_country', value: countryVal, operation: 'equals' });
    if (siteVal !== '') qf.push({ name: 'tmf_doc_site', value: siteVal, operation: 'equals' });
    if (milestoneVal !== '') qf.push({ name: 'tmf_doc_milestone', value: milestoneVal, operation: 'equals' });
    if (mileStatusVal !== '') qf.push({ name: 'tmf_doc_milestone_status', value: mileStatusVal, operation: 'equals' });
    if (departmentVal !== '') qf.push({ name: 'tmf_doc_viewer_department', value: departmentVal, operation: 'equals' });
    if (productVal !== '') qf.push({ name: 'tmf_doc_viewer_product_detail', value: productVal, operation: 'equals' });
    if (createdbyVal !== '') qf.push({ name: 'tmf_doc_created_by', value: createdbyVal, operation: 'equals' });
    if (modifiedbyVal !== '') qf.push({ name: 'tmf_doc_last_modified_by', value: modifiedbyVal, operation: 'equals' });
    if (qcissueVal !== '') qf.push({ name: 'tmf_doc_viewer_qc_issue_type', value: qcissueVal, operation: 'equals' });
    if (qccommentVal !== '')
      qf.push({ name: 'tmf_doc_viewer_qc_issue_comments', value: qccommentVal, operation: 'case_insensitive_like' });
    if (certifyRequired) {
      qf.push({ name: 'tmf_doc_viewer_req_certified_copy', value: 'Y', operation: operator });
    } else {
      qf.push({ name: 'tmf_doc_viewer_req_certified_copy', value: 'N', operation: operator });
    }
    if (uploadedFromDate !== null) {
      qf.push({
        name: 'created_on',
        value: moment(new Date(uploadedFromDate)).format(userPreferedDateFormat.toUpperCase()) + ' 00:00:00',
        operation: 'greater_than_or_equal'
      });
    }
    if (uploadedToDate !== null) {
      qf.push({
        name: 'created_on',
        value: moment(new Date(uploadedToDate)).format(userPreferedDateFormat.toUpperCase()) + ' 23:59:59',
        operation: 'less_than_or_equal'
      });
    }
    if (modifiedFromDate !== null) {
      qf.push({
        name: 'updated_on',
        value: moment(new Date(modifiedFromDate)).format(userPreferedDateFormat.toUpperCase()) + ' 00:00:00',
        operation: 'greater_than_or_equal'
      });
    }
    if (modifiedToDate !== null) {
      qf.push({
        name: 'updated_on',
        value: moment(new Date(modifiedToDate)).format(userPreferedDateFormat.toUpperCase()) + ' 23:59:59',
        operation: 'less_than_or_equal'
      });
    }
    return qf;
  };

  const advancedFilterSearch = async (from: number, size: number) => {
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'AdvanceSearch'
    };
    if (handleInvalidDate()) return;
    setSearchResultRows([]);
    setIsAdvanceSearch(true);
    setIsPresetSearch(false);
    setShowResult(false);
    setInputValue('');
    handleCloseFilter();
    const res = buildPayload();
    setBadgeCount(qf.length);
    const dataObj = {
      query_filters: qf,
      filter_types: findScope()
    };
    try {
      const response: any = await docService.getGlobalSearch(dataObj, null, null, null, 'None', params, from, size);
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } catch (error) {
      setShowResult(true);
    }
  };

  const presetFilterSearch = async (from: number, size: number) => {
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'PresetSearch'
    };
    setIsEditStarted(false);
    setIsPresetSearch(true);
    setCertifyRequired(presetObject && presetObject.tmf_doc_viewer_req_certified_copy === 'N' ? false : true);
    for (const prop in presetFilter) {
      if (presetFilter[prop].operation === 'greater_than_or_equal' && presetFilter[prop].name === 'created_on') {
        setuploadedFromDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'less_than_or_equal' && presetFilter[prop].name === 'created_on') {
        setuploadedToDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'greater_than_or_equal' && presetFilter[prop].name === 'updated_on') {
        setmodifiedFromDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'less_than_or_equal' && presetFilter[prop].name === 'updated_on') {
        setmodifiedToDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_type') {
        setTypeVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_subtype') {
        setSubTypeVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_artifact_name') {
        setArtifactNameVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_status') {
        setDocStatusVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_document_name') {
        setDocNameVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_document_id') {
        setDocIdVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_level') {
        setDocLevelVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_study') {
        setDocStudyVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_country') {
        setCountryVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_site') {
        setSiteVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_milestone') {
        setMilestoneVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_milestone_status') {
        setMileStatusVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_viewer_department') {
        setDepartmentVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_viewer_product_detail') {
        setProductVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_created_by') {
        setCreatedbyVal(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_last_modified_by') {
        setModifiedbyVal(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_viewer_qc_issue_type') {
        setQcissueVal(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'tmf_doc_viewer_qc_issue_comments') {
        setQccommentVal(presetFilter[prop].value);
        setP3Expand(true);
      }
    }
    setPresetSearchData({ ...presetSearchData });
    setOpen(false);
    setBadgeCount(presetFilter.length);
    setSearchResultRows([]);
    setShowResult(false);
    setInputValue('');
    const dataObj = {
      query_filters: presetFilter,
      filter_types: findScope()
    };
    setObjData(dataObj);
    const response: any = await docService.getGlobalSearch(dataObj, null, null, null, 'None', params, from, size);
    if (response.data) {
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } else {
      if (presetFilter) {
        setShowResult(true);
      }
    }
  };

  const findScope = () => {
    let arr: string[] = [];
    if (NameCbx) arr.push('Name');
    if (DetailCbx) arr.push('Detail');
    if (PropertiesCbx) arr.push('Properties');
    if (ContentCbx) arr.push('Content');
    if (NameCbx && DetailCbx && PropertiesCbx && ContentCbx) arr = ['All'];
    return arr;
  };

  const globalSearchFromHistory = async (i: any, from: number, size: number) => {
    setFromHistory(true);
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'SearchHistory'
    };
    setAnchorElSearch(null);
    setInputValue(recentHistoryResult[i]['actual_value']);
    const dataObj = {
      query_filters: [
        {
          name: recentHistoryResult[i]['filter_column'],
          value: recentHistoryResult[i]['actual_value'],
          operation: operator
        }
      ],
      filter_types: findScope()
    };
    setObjData(i);
    const response: any = await docService.getGlobalSearch(dataObj, null, null, null, 'None', params, from, size);
    const modRows: any = getMapFields(response?.data?.selected_data);
    setShowResult(true);
    setSearchResultRows(modRows);
    setRowCount(response.data.record_count);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      setSearchResultRows([]);
      globalSearch(0, 'enter', 0, pageSize);
      setShowResult(true);
    }
  };

  const handleClickInsideInput = (e: any) => {
    setAnchorElSearch(null);
    if (inputValue === '' && recentHistoryResult.length !== 0) {
      setAnchorElSearch(e.currentTarget);
      setShowHistory(!showHistory);
    }
  };

  const getAdvSearchData = async () => {
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'AdvanceSearch'
    };
    const res: any = await docService.getBinderViewerTree(
      TmfLevel,
      selectedStudy,
      selectedCountry,
      selectedSite,
      params
    );
    const treeList = [];
    const type = [];
    const subType = [];
    const artifactName = [];
    if (res.data) {
      for (const x of res.data) {
        type.push(x.tmf_document_type);
        for (const y of x.tmf_document_subtype) {
          subType.push(y.tmf_document_subtype);
          for (const z of y.tmf_artifact) {
            artifactName.push(z.tmf_artifact_name);
          }
        }
      }
      treeList.push(res.data);
      setType(type);
      setSubType([...new Set(subType)]);
      setArtifactName([...new Set(artifactName)]);
    } else {
      store.dispatch(setSnackbarMessage('Error in Getting advanced filter details', 'error'));
    }
    setTreeData(treeList[0]);
  };

  const formatToDate = (params: any) => {
    const valueFormatted = String(params).split('T')[0].split('-');
    return `${valueFormatted[1]}/${valueFormatted[2]}/${valueFormatted[0]}`;
  };

  const handleClear = () => {
    // setClear(true);
    setMetaData({});
    setBadgeCount(0);
    setTypeVal('');
    setInputTypeVal('');
    setSubTypeVal('');
    setInputSubTypeVal('');
    setArtifactNameVal('');
    setInputArtifactNameVal('');
    setDocStatusVal('');
    setDocNameVal('');
    if (docNameInput && docNameInput.current) docNameInput.current.value = '';
    if (docNoInput && docNoInput.current) docNoInput.current.value = '';
    if (qcCommentsInput && qcCommentsInput.current) qcCommentsInput.current.value = '';
    setDocIdVal('');
    setDocLevelVal('');
    setDocStudyVal('');
    setCountryVal('');
    setSiteVal('');
    setMilestoneVal('');
    setMileStatusVal('');
    setDepartmentVal('');
    setProductVal('');
    setCreatedbyVal('');
    setModifiedbyVal('');
    setQcissueVal('');
    setQccommentVal('');
    setuploadedFromDate(null);
    setuploadedToDate(null);
    setmodifiedFromDate(null);
    setmodifiedToDate(null);
    setCertifyRequired(true);
    // setShowResult(false);
  };

  useEffect(() => {
    getAdvSearchData();
    getMasterCodeList();
    getAllUsers();
    window.scrollTo(0, 0);
    setDataGridComponent(true);
    return () => {
      props.routeInfo(null);
    };
  }, []);

  useEffect(() => {
    if (isPreset) {
      presetFilterSearch(0, pageSize);
    }
    setMetaData({ ...presetObject });
    setPresetId(presetSearchData.id);
  }, [presetFilter]);
  useEffect(() => {
    setMetaData({ ...presetObject });
    setPresetId(presetSearchData.id);
    setOpenDeletePreset(false);
    presetFilterSearch(0, pageSize);
  }, [isEdit]);

  const [currentStudy, setCurrentStudy] = useState('');
  const [currentCountry, setCurrentCountry] = useState('');
  const [countryList, setCountryList] = useState<any>([]);

  const {
    isLoading: getStudyLoad,
    data: studyData,
    isError: getStudyError,
    isSuccess: getStudySuccess,
    refetch: getStudyList
  } = useGetStudiesQuery();

  useEffect(() => {
    const temp: string[] = [];
    if (studyData && studyData.length != 0) {
      studyData.map((study: any) => {
        temp.push(study.name);
      });
    }
    setStudyList(temp);
  }, [studyData]);

  const {
    isLoading,
    data: countryData,
    isError,
    isSuccess,
    refetch: getCountries
  } = useGetCountriesQuery(currentStudy);

  useEffect(() => {
    getCountries();
  }, [currentStudy]);

  useEffect(() => {
    const tempC: any = [];
    if (countryData && countryData.length != 0) {
      countryData.map((country: any) => {
        tempC.push(country.name);
      });
    }
    setCountryList(tempC);
  }, [countryData]);

  const {
    isLoading: getSiteLoading,
    data: sitesData,
    isError: getSiteError,
    isSuccess: getSiteSuccess,
    refetch: getSites
  } = useGetSitesQuery({ currentStudy, currentCountry });

  useEffect(() => {
    getSites();
  }, [currentCountry]);

  useEffect(() => {
    const tempS: string[] = [];
    if (sitesData && sitesData.length != 0) {
      sitesData.map((site: any) => {
        tempS.push(site.name);
      });
    }
    setSiteList(tempS);
  }, [sitesData]);

  const handleChangeFilter = (e: any) => {
    setFilter(e.target.value);
    const temp = e.target.value == 'Newest' ? 'desc' : 'asc';
  };

  const [value, setValue] = React.useState(0);
  const [filter, setFilter] = React.useState('Newest');

  const handleChangeTab = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  // All button dropdown with checkbox
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSaveDialogBox = () => {
    setEnable(true);
    setAnchorElSearch(null);
    setDisablePresetSave(true);
  };
  const handleSaveClose = () => {
    setEnable(false);
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };
  const formatDate = (params: any) => {
    return preferedDateFormat(params.value);
  };
  const [AllCbx, setAllCbx] = useState<boolean>(true);
  const [NameCbx, setNameCbx] = useState<boolean>(true);
  const [DetailCbx, setDetailCbx] = useState<boolean>(true);
  const [PropertiesCbx, setPropertiesCbx] = useState<boolean>(true);
  const [ContentCbx, setContentCbx] = useState<boolean>(true);
  const [scopeText, setScopeText] = useState<string>('All');

  const handleChangeAllCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAllCbx(!AllCbx);
    if (event.target.checked) {
      setNameCbx(true);
      setDetailCbx(true);
      setPropertiesCbx(true);
      setContentCbx(true);
    } else {
      setNameCbx(false);
      setDetailCbx(false);
      setPropertiesCbx(false);
      setContentCbx(false);
    }
  };
  const handleChangeNameCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameCbx(!NameCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (DetailCbx && PropertiesCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangeDetailCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetailCbx(!DetailCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && PropertiesCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangePropertiesCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPropertiesCbx(!PropertiesCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && DetailCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangeContentCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContentCbx(!ContentCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && PropertiesCbx && DetailCbx) {
        setAllCbx(true);
      }
    }
  };

  const handlePresetName = (e: any) => {
    if (e.target.value.trim()) {
      setDisablePresetSave(false);
      setPresetName(e.target.value);
    } else {
      setDisablePresetSave(true);
    }
  };

  useEffect(() => {
    let sCount = 0;
    if (NameCbx) sCount++;
    if (DetailCbx) sCount++;
    if (PropertiesCbx) sCount++;
    if (ContentCbx) sCount++;
    if (NameCbx && DetailCbx && PropertiesCbx && ContentCbx) sCount = 5;
    if (sCount === 5) setScopeText(`All`);
    else if (sCount === 0) setScopeText(`Select`);
    else setScopeText(`${sCount} Selected`);
  }, [AllCbx, NameCbx, DetailCbx, PropertiesCbx, ContentCbx]);

  const [anchorElSearch, setAnchorElSearch] = React.useState<HTMLButtonElement | null>(null);

  const handleClickSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElSearch(event.currentTarget);
  };

  const handleCloseSearch = () => {
    setAnchorElSearch(null);
  };

  const handleClickSearchInput = React.useState<null | HTMLElement>(null);

  const open2 = Boolean(anchorElSearch);
  const id = open2 ? 'simple-popover' : undefined;
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [anchorElFilter, setAnchorElFilter] = React.useState<HTMLButtonElement | null>(null);
  const [open3, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState<PopperPlacementType>();
  const { checkPermission } = usePermissionWrapper();
  const handleClickFilter = (newPlacement: PopperPlacementType) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setClear(false);
    setAnchorElFilter(event.currentTarget);
    if (isEdit) {
      setPresetSearchData({ ...presetSearchData, isEdit: false });
      setOpen(false);
    } else {
      setOpen(prev => placement !== newPlacement || !prev);
    }
    setPlacement(newPlacement);
  };

  const handleClickAway = (event: any) => {
    if (event.target.localName === 'body') {
      return;
    }
    if (isEdit) setPresetSearchData({ isPreset: true, isEdit: false });
    setOpen(false);
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpen(false);
  };

  const [filtervalue, setFilterValue] = React.useState('');

  const [openDeletePreset, setOpenDeletePreset] = React.useState(false);
  const handleCloseDeletePreset = () => {
    setOpenDeletePreset(false);
    setPresetSearchData({ ...presetSearchData, isDeletePreset: false });
  };
  const handleDeletePreset = async (isDelete: boolean) => {
    setSave(false);
    const presetData: any = {
      deleted_by: userName
    };
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'Presetdelete'
    };
    const response: any = await docService.deletePresetFilter(
      presetId,
      presetData,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel,
      params
    );
    if (response.data) {
      setSave(isDelete);
      store.dispatch(setSnackbarMessage('Filter preset is deleted successfully.', 'success'));
      handleClear();
      setShowResult(false);
      setPresetSearchData({ ...presetSearchData, isDeletePreset: false });
    } else {
      store.dispatch(setSnackbarMessage('Error in delete Preset.', 'error'));
    }
    setOpenDeletePreset(false);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    tmf_artifact_name: false,
    tmf_doc_type: false,
    tmf_doc_subtype: false
  });

  const gethashedurikey = (params: any) => {
    const data: any = searchResultRows.find((item: any) => item.id === params.id);
    setDataResult(data);
    return data.hashed_uri_key;
  };

  const [pageSize, setPageSize] = React.useState<number>(10);
  const appName = 'ETMF';
  const columns: GridColDef[] = [
    {
      field: 'documentName',
      headerName: 'Document Name',
      flex: 1,
      minWidth: 200,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) =>
        checkPermission('view_document_details') ? (
          <Tooltip title={params.value!.toString()} placement="top">
            <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
          </Tooltip>
        ) : (
          params.value!.toString()
        )
    },
    {
      field: 'filingLevel',
      headerName: 'Filing Level',
      flex: 1,
      minWidth: 120
    },
    {
      field: 'lastModified',
      headerName: 'Last Modified',
      flex: 1,
      minWidth: 130,
      valueGetter: formatDate
    },
    {
      field: 'uploadedBy',
      headerName: 'Uploaded By',
      flex: 1,
      minWidth: 150
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 110
    },
    {
      field: 'tmf_artifact_name',
      headerName: 'Artifact Name',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'tmf_doc_type',
      headerName: 'Document Type',
      flex: 1,
      minWidth: 180
    },
    {
      field: 'tmf_doc_subtype',
      headerName: 'Document Subtype',
      flex: 1,
      minWidth: 180
    }
  ];

  const rows = [];

  function CustomToolbar() {
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName = 'Search Results ' + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    // const documentName = 'Search Results ' + exportDate;
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        {checkPermission('export_search_results') && (
          <GridToolbarExport
            csvOptions={{
              fileName: documentName
            }}
          />
        )}
      </GridToolbarContainer>
    );
  }

  const [uploadedFromDate, setuploadedFromDate] = React.useState<Date | null>(null);
  const [uploadedToDate, setuploadedToDate] = React.useState<Date | null>(null);
  const [modifiedFromDate, setmodifiedFromDate] = React.useState<Date | null>(null);
  const [modifiedToDate, setmodifiedToDate] = React.useState<Date | null>(null);
  const [errorUploadedFromDate, setErrorUploadedFromDate] = useState<string>('');
  const [errorUploadedToDate, setErrorUploadedToDate] = useState<string>('');
  const [errorModifiedFromDate, setErrorModifiedFromDate] = useState<string>('');
  const [errorModifiedToDate, setErrorModifiedToDate] = useState<string>('');
  const handleInvalidUploadedFromDate = (err: any, value: any) => {
    if (err === null) setErrorUploadedFromDate('');
    if (err === 'minDate') {
      setErrorUploadedFromDate('From date cannot be more then From To');
    } else if (err === 'disableFuture') {
      setErrorUploadedFromDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorUploadedFromDate('Invalid date(s)');
    }
  };
  const handleInvalidUploadedToDate = (err: any, value: any) => {
    if (err === null) setErrorUploadedToDate('');
    if (err === 'minDate') {
      setErrorUploadedToDate('To date cannot be less then From date');
    } else if (err === 'disableFuture') {
      setErrorUploadedToDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorUploadedToDate('Invalid date(s)');
    }
  };
  const handleInvalidModifiedFromDate = (err: any, value: any) => {
    if (err === null) setErrorModifiedFromDate('');
    if (err === 'minDate') {
      setErrorModifiedFromDate('From date cannot be more then From To');
    } else if (err === 'disableFuture') {
      setErrorModifiedFromDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorModifiedFromDate('Invalid date(s)');
    }
  };
  const handleInvalidModifiedToDate = (err: any, value: any) => {
    if (err === null) setErrorModifiedToDate('');
    if (err === 'minDate') {
      setErrorModifiedToDate('To date cannot be less then From date');
    } else if (err === 'disableFuture') {
      setErrorModifiedToDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorModifiedToDate('Invalid date(s)');
    }
  };
  const handleInvalidDate = () => {
    if (errorUploadedFromDate !== '') {
      store.dispatch(setSnackbarMessage(errorUploadedFromDate, 'error'));
      return true;
    } else if (errorUploadedToDate !== '') {
      store.dispatch(setSnackbarMessage(errorUploadedToDate, 'error'));
      return true;
    } else if (errorModifiedFromDate !== '') {
      store.dispatch(setSnackbarMessage(errorModifiedFromDate, 'error'));
      return true;
    } else if (errorModifiedToDate !== '') {
      store.dispatch(setSnackbarMessage(errorModifiedToDate, 'error'));
      return true;
    } else {
      return false;
    }
  };
  const [anchorElPresetFilterBtn, setAnchorElPresetFilterBtn] = React.useState<null | HTMLElement>(null);
  const openPresetFilterBtn = Boolean(anchorElPresetFilterBtn);
  const handleClickPresetFilterBtn = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElPresetFilterBtn(event.currentTarget);
  };
  const handleClosePresetFilterBtn = () => {
    setAnchorElPresetFilterBtn(null);
  };

  const handleSavePresetFilter = async (isSave: boolean) => {
    setSave(false);
    const res_qf = buildPayload();
    const filterObj = {
      preset_name: presetName,
      preset_conditions: {
        filter: res_qf,
        sort: [
          {
            sort_by: 'string',
            sort_order: 'desc'
          }
        ],
        page: {
          start_from: 0,
          size: 10
        }
      },
      created_by: userName
    };
    const params = {
      module_section_related: 'Search',
      parent_entity_related: 'PresetCreate'
    };
    const res: any = await docService.createFilterPreset(
      params,
      filterObj,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );

    if (res.error) {
      store.dispatch(setSnackbarMessage('Name already exist.', 'error'));
    } else {
      handleClear();
      handleSaveClose();
      setAnchorElFilter(null);
      setOpen(false);
      setSave(isSave);
      store.dispatch(setSnackbarMessage('Search Preset is saved successfully.', 'success'));
    }
  };

  const cancelEditPresetFilter = () => {
    setPresetSearchData({ isPreset: false, isEdit: false });
    setAnchorElFilter(null);
    setOpen(false);
    handleClear();
    setClear(true);
    // setShowResult(false);
    // setSearchResultRows([]);
  };
  const handleEditPresetFilter = async (from: number, size: number) => {
    setMetaData({});
    setPresetSearchData({ isPreset: false, isEdit: false });
    setAnchorElFilter(null);
    setOpen(false);
    handleClear();
    // setClear(false);
    setSave(false);
    setShowResult(false);
    const res_qf = buildPayload();

    // setBadgeCount(res_qf.length);
    if (presetId) {
      const editObj = {
        preset_name: presetName ? presetName : presetSearchData.preset_name,
        id: presetId,
        preset_conditions: {
          filter: res_qf,
          sort: [
            {
              sort_by: 'string',
              sort_order: 'desc'
            }
          ],
          page: {
            start_from: 0,
            size: 10
          }
        },
        updated_by: userName
      };
      const params = {
        module_section_related: 'Search',
        parent_entity_related: 'PresetUpdate'
      };
      const res: any = await docService.updatePresetFilter(
        params,
        editObj,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel
      );
      if (res.error) {
        store.dispatch(setSnackbarMessage('Name already exists.', 'error'));
        setSearchResultRows([]);
      } else {
        setSave(true);
        setAnchorElFilter(null);
        setOpen(false);
        const dataObj = {
          query_filters: res_qf,
          filter_types: findScope()
        };
        const response: any = await docService.getGlobalSearch(dataObj, null, null, null, 'None', params, from, size);
        if (response.data) {
          const modRows: any = getMapFields(response?.data?.selected_data);
          setShowResult(true);
          setSearchResultRows(modRows);
          setRowCount(response.data.record_count);
        } else {
          setSearchResultRows([]);
          setShowResult(true);
        }
        store.dispatch(setSnackbarMessage('Filter preset is modified successfully.', 'success'));
      }
    }
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 300, // phone
        sm: 600, // tablets
        md: 900, // small laptop
        lg: 1200, // desktop
        xl: 1600 // large screens
      }
    }
  });

  const getMapFields = (data: any) => {
    const responseData = data.map((item: any, key: any) => {
      return {
        id: item.document_data.id,
        documentName: item.document_data.tmf_document_name,
        filingLevel: item.document_data.tmf_doc_level,
        lastModified: formatToDate(item.document_data.updated_on),
        uploadedBy: item.document_data.tmf_doc_created_by,
        status: item.document_data.tmf_doc_status,
        created_on: item.document_data.created_on,
        deleted_by: item.document_data.deleted_by,
        deleted_on: item.document_data.deleted_on,
        docFormat: item.file_master.tmf_doc_type,
        fileId: item.file_master.id,
        fmId: item.file_master.id,
        is_active: item.file_master.is_active,
        tmf_artifact_name: item.document_data.tmf_artifact_name,
        tmf_artifact_number: item.document_data.tmf_artifact_number,
        tmf_bucket_name: item.file_master.tmf_bucket_name,
        tmf_doc_approval_date: item.document_data.tmf_doc_approval_date,
        tmf_doc_approval_st_dt: item.document_data.tmf_doc_approval_st_dt,
        tmf_doc_country: item.document_data.tmf_doc_country,
        tmf_doc_created_by: item.document_data.tmf_doc_created_by,
        tmf_doc_date: item.document_data.tmf_doc_date,
        tmf_doc_last_modified_by: item.document_data.tmf_doc_last_modified_by,
        tmf_doc_level: item.document_data.tmf_doc_level,
        tmf_doc_milestone: item.document_data.tmf_doc_milestone,
        tmf_doc_site: item.document_data.tmf_doc_site,
        tmf_doc_size: item.file_master.tmf_doc_size,
        tmf_doc_status: item.document_data.tmf_doc_status,
        tmf_doc_study: item.document_data.tmf_doc_study,
        tmf_doc_subtype: item.document_data.tmf_doc_subtype,
        tmf_doc_type: item.document_data.tmf_doc_type,
        tmf_doc_upload_date: item.document_data.tmf_doc_upload_date,
        tmf_doc_version_number: item.document_data.tmf_doc_version_number,
        tmf_doc_viewer_approval_cycle: item.document_data.tmf_doc_viewer_approval_cycle,
        tmf_doc_viewer_department: item.document_data.tmf_doc_viewer_department,
        tmf_doc_viewer_format: item.document_data.tmf_doc_viewer_format,
        tmf_doc_viewer_inspection_ready: item.document_data.tmf_doc_viewer_inspection_ready,
        tmf_doc_viewer_ir_issue_type: item.document_data.tmf_doc_viewer_ir_issue_type,
        tmf_doc_viewer_language: item.document_data.tmf_doc_viewer_language,
        tmf_doc_viewer_pages: item.file_master.tmf_doc_viewer_pages,
        tmf_doc_viewer_product_detail: item.document_data.tmf_doc_viewer_product_detail,
        tmf_doc_viewer_ref_model_version: item.document_data.tmf_doc_viewer_ref_model_version,
        tmf_doc_viewer_req_certified_copy: item.document_data.tmf_doc_viewer_req_certified_copy,
        tmf_document_id: item.document_data.tmf_document_id,
        tmf_document_name: item.document_data.tmf_document_name,
        tmf_hashed_file_name: item.file_master.tmf_hashed_file_name,
        tmf_prefix: item.file_master.tmf_prefix,
        tmf_raw_file_name: item.file_master.tmf_raw_file_name,
        updated_on: item.document_data.updated_on,
        hashed_uri_key: item.hashed_uri_key,
        sent_to_isf: item.document_data.sent_to_isf,
        need_to_sent_to_isf: item.need_to_sent_to_isf
      };
    });
    return responseData;
  };

  const [dataGridComponent, setDataGridComponent] = useState<boolean>(true);
  const [documentToDisplaySearch, setDocumentToDisplaySearch] = useState<any>();
  const [isAdvanceSearch, setIsAdvanceSearch] = useState<boolean>(false);
  const [isPresetSearch, setIsPresetSearch] = useState<boolean>(false);

  const gridFunc = async (searchResultRows: any) => {
    try {
      const response: any = await docService.getDocAccessPermissions(searchResultRows);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        window.scrollTo(0, 0);
        setDocumentToDisplaySearch(searchResultRows);
        setDocumentDetail(dispatch, [searchResultRows]);
        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };

  useEffect(() => {
    if (dataGridComponent || props.onClicked) {
      props.routeInfo && props.routeInfo('');
      setDataGridComponent(true);
      if (isAdvanceSearch === true) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          advancedFilterSearch(0, pageSize);
        } else advancedFilterSearch(page * pageSize, pageSize);
      } else if (isPresetSearch === true) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          presetFilterSearch(0, pageSize);
        } else presetFilterSearch(page * pageSize, pageSize);
      } else {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          globalSearch(objData, isAction, 0, pageSize);
        } else globalSearch(objData, isAction, page * pageSize, pageSize);
      }
    } else {
      props.routeInfo && props.routeInfo('search');
    }
  }, [page, pageSize, dataGridComponent, props.onClicked]);

  useEffect(() => {
    if (isDeletePreset) {
      setOpenDeletePreset(true);
      setPresetId(presetSearchData.id);
    }
  }, [isDeletePreset]);

  useEffect(() => {
    if (isEditStarted === true) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        handleEditPresetFilter(0, pageSize);
      } else handleEditPresetFilter(page * pageSize, pageSize);
    }
    if (fromHistory === true) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        globalSearchFromHistory(0, 0, pageSize);
      } else globalSearchFromHistory(0, page * pageSize, pageSize);
    }
  }, [page, pageSize]);

  // for Send to ISF Dialog
  const [openSend, setOpenSend] = React.useState(false);
  const [noOfRows, setNoOfRows] = useState<any>([]);
  const [allNewFiles, setAllNewFiles] = useState([]);
  const [isfToBePublishedFiles, setIsfToBePublishedFiles] = useState([]);
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [overwrite, setOverwrite] = useState<boolean>(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [isEnable, setIsEnable] = useState<boolean>(true);

  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const filesSelected = searchResultRows
      .filter((row: any) => selectedIds.has(row.id))
      .filter(
        (elem: any) =>
          elem.tmf_doc_status === 'Approved' &&
          elem.need_to_sent_to_isf === 'Yes' &&
          elem.tmf_doc_viewer_ref_model_version.slice(0, 3) === 'TMF' &&
          elem.filingLevel === 'Site' &&
          elem.tmf_doc_version_number % 1 === 0
      );
    setSelectedFiles(filesSelected);

    const rowSelected = searchResultRows.filter((row: any) => selectedIds.has(row.id)).map((elem: any) => elem.fileId);
    setSelectedRows(rowSelected);
    setNoOfRows(rowSelected);
  };

  const filterFiles = async () => {
    setLoaderStatus(true);
    if (selectedFiles.length > 0) {
      const tempNewFiles: any = [];
      selectedFiles.forEach((file: any) => {
        if (file.sent_to_isf === false) {
          tempNewFiles.push(file);
        }
      });
      const newVersionFiles: any = [];
      const overwriteOrNewVersionFiles: any = [];
      if (tempNewFiles.length > 0) {
        const payload = { tmf_document_ids: tempNewFiles.map((file: any) => file.tmf_document_id) };
        const resp: any = await docService.VersionBasedDocument(payload);
        if (resp.data && resp.data.length > 0) {
          tempNewFiles.forEach((file: any) => {
            if (resp.data.find((resFile: any) => resFile.tmf_document_id === file.tmf_document_id)) {
              overwriteOrNewVersionFiles.push(file);
            } else {
              newVersionFiles.push(file);
            }
          });
          setAllNewFiles(newVersionFiles);
        } else {
          setAllNewFiles(tempNewFiles);
        }
        setIsfToBePublishedFiles(overwriteOrNewVersionFiles);
      }

      if (overwriteOrNewVersionFiles.length === 0 && (newVersionFiles.length > 0 || tempNewFiles.length > 0)) {
        const fileIds = (newVersionFiles.length > 0 ? newVersionFiles : tempNewFiles)
          .filter((item: any) => item)
          .map((item: any) => item.id);
        const data = { doucment_id: [...fileIds] };
        const response = await docService.BulkUpload(false, 'Search', data);
        if (response.data) {
          if (
            response.data.pushed_documents.doucment_name?.length > 0 ||
            response.data.multiple_mapped_documents.doucment_name?.length > 0
          ) {
            if (response.data.pushed_documents.doucment_name?.length > 0) {
              const variant: VariantType = 'success';
              enqueueSnackbar(`Document(s) sent to ISF successfully.`, {
                variant
              });
            }
            if (response.data.multiple_mapped_documents.doucment_name?.length > 0) {
              const variant: VariantType = 'info';
              enqueueSnackbar(
                `The selected ${response.data.multiple_mapped_documents.doucment_name?.join(
                  ','
                )} artifact is mapped to multiple artifacts. Please go to the individual document send to ISF option to complete the activity`,
                {
                  variant
                }
              );
            }
            globalSearch(objData, isAction, 0, pageSize);
            onSelectionModelChange([]);
          } else {
            store.dispatch(
              setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error')
            );
          }
        } else {
          store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
        }
      } else if (newVersionFiles.length === 0 && tempNewFiles.length === 0) {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
      } else {
        setOpenSend(true);
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
    }
    setLoaderStatus(false);
  };
  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    if (value === 'newVersion') {
      setOverwrite(false);
    } else {
      setOverwrite(true);
    }
  };

  const handleClickOpenSend = () => {
    if (noOfRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to be sent to ISF at once', 'error'));
    } else {
      filterFiles();
    }
  };
  const handleCloseSendToISF = () => {
    setChecked(false);
    setOpenSend(false);
  };
  const handleCloseSend = async () => {
    setLoaderStatus(true);
    let response1: any = [];
    let response2: any = [];

    if (isfToBePublishedFiles.length > 0) {
      if (overwrite) {
        response1 = await docService.BulkUpload(true, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      } else {
        response1 = await docService.BulkUpload(false, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      }
    }
    if (allNewFiles.length > 0) {
      response2 = await docService.BulkUpload(false, 'Search', {
        doucment_id: allNewFiles.map((file: any) => file.id)
      });
    }

    const pushedDocsLists: string[] = [];
    const mappedMultiDocsLists: string[] = [];
    if (response1.data || response2.data) {
      response1.data &&
        response1.data.pushed_documents.doucment_name &&
        pushedDocsLists.push(response1.data.pushed_documents.doucment_name);
      response1.data &&
        response1.data.multiple_mapped_documents.doucment_name &&
        mappedMultiDocsLists.push(response1.data.multiple_mapped_documents.doucment_name);
      response2.data &&
        response2.data.pushed_documents.doucment_name &&
        pushedDocsLists.push(response2.data.pushed_documents.doucment_name);
      response2.data &&
        response2.data.multiple_mapped_documents.doucment_name &&
        mappedMultiDocsLists.push(response2.data.multiple_mapped_documents.doucment_name);
    }
    if (pushedDocsLists.length > 0 || mappedMultiDocsLists.length > 0) {
      if (pushedDocsLists.length > 0) {
        const variant: VariantType = 'success';
        enqueueSnackbar(`Document(s) sent to ISF successfully.`, {
          variant
        });
      }
      if (mappedMultiDocsLists.length > 0) {
        const variant: VariantType = 'info';
        enqueueSnackbar(
          `The selected ${mappedMultiDocsLists?.join(
            ','
          )} artifact is mapped to multiple artifacts. Please go to the individual document send to ISF option to complete the activity`,
          {
            variant
          }
        );
      }
      globalSearch(objData, isAction, 0, pageSize);
      onSelectionModelChange([]);
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
    }
    setOpenSend(false);
    setLoaderStatus(false);
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setIsEnable(false);
    } else {
      setIsEnable(true);
    }
  }, [selectedRows]);

  const url = `${config.appConfig.apietmf}/fileMaster/downloadFiles?tmf_doc_level=${TmfLevel}&application=ETMF&module_section_related=Search&log=Y&original=N&bulk_download=true`;
  const payload: any = {
    id: selectedRows
  };

  const axiosOptions: any = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const handleBulkDownload = (url: any) => {
    if (selectedRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to download at once', 'error'));
    } else {
      setLoading(true);
      axios
        .post(url, payload, axiosOptions)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const filename = 'TMF_Search_Bulk_Download.zip';
          saveAs(blob, filename);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  };

  if (loading)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      </>
    );

  // for Custom buttons at Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }} className="customFtBtnWrap">
          {checkPermission('bulk_download') && (
            <Button variant="outlined" onClick={() => handleBulkDownload(url)} disabled={isEnable}>
              Download
            </Button>
          )}
          <Tooltip
            placement="top"
            title="Only documents configured to be sent to ISF in 'Planning' and those in 'Approved' status will be sent to ISF"
          >
            <Button
              variant="outlined"
              onClick={handleClickOpenSend}
              className={checkPermission('send_to_isf') ? '' : 'hide'}
              disabled={noOfRows.length <= 0}
            >
              Send to ISF
            </Button>
          </Tooltip>
        </Box>

        <GridFooter />
      </GridFooterContainer>
    );
  }

  return (
    <React.Fragment>
      {dataGridComponent ? (
        <div>
          <>
            <Box>
              <Grid container className="search-block" spacing={2}>
                <Grid item md={9}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div>
                      <Button
                        id="all-button"
                        aria-controls={open ? 'all-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        variant="contained"
                        disableElevation
                        onClick={handleClick}
                        endIcon={<ArrowDropDownIcon />}
                        className="searchAll-btn"
                      >
                        <span>{scopeText}</span>
                      </Button>

                      <StyledMenu
                        id="all-menu"
                        MenuListProps={{
                          'aria-labelledby': 'all-button'
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{
                          style: {
                            maxHeight: ITEM_HEIGHT * 5,
                            width: '175'
                          }
                        }}
                        className="allDropDownMenu"
                      >
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="All" checked={AllCbx} onChange={handleChangeAllCbx} />}
                            label="All"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="Name" checked={NameCbx} onChange={handleChangeNameCbx} />}
                            label="Name"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="Detail" checked={DetailCbx} onChange={handleChangeDetailCbx} />}
                            label="Details"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={
                              <Checkbox
                                value="Properties"
                                checked={PropertiesCbx}
                                onChange={handleChangePropertiesCbx}
                              />
                            }
                            label="Properties"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={
                              <Checkbox value="Content" checked={ContentCbx} onChange={handleChangeContentCbx} />
                            }
                            label="Content"
                          />
                        </MenuItem>
                      </StyledMenu>
                    </div>
                    <FormControl variant="standard">
                      <Input
                        id="input-with-icon-adornment"
                        onChange={handleSearchInputChange}
                        onKeyDown={handleKeyDown}
                        onClick={handleClickInsideInput}
                        autoComplete="off"
                        value={inputValue}
                        className="search-main-input"
                        placeholder="Search by document name, status, version, type, etc"
                        startAdornment={
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-controls={open ? 'long-menu' : undefined}
                              aria-expanded={open ? 'true' : undefined}
                              aria-haspopup="true"
                              onClick={handleClickSearch}
                            >
                              <SearchIcon />
                            </IconButton>
                            {(showSuggestion || showHistory) &&
                              (suggestionResult?.length > 0 || recentHistoryResult?.length > 0) && (
                                <Popover
                                  id={id}
                                  open={open2}
                                  anchorEl={anchorElSearch}
                                  onClose={handleCloseSearch}
                                  anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                  }}
                                  className={'SearchItemsPop' + (showHistory === true ? ' withHistory' : ' noHistory')}
                                  disableAutoFocus={true}
                                >
                                  <MenuList>
                                    {showSuggestion &&
                                      suggestionResult?.map((item: any, i: any) => {
                                        return (
                                          <MenuItem
                                            disableRipple
                                            key={i}
                                            onClick={() => globalSearch(i, 'click', 0, pageSize)}
                                          >
                                            {`${item.actual_value}`} -&nbsp;&nbsp;{' '}
                                            <span className="column_name"> {item.filter_column} </span>
                                          </MenuItem>
                                        );
                                      })}

                                    {showHistory &&
                                      recentHistoryResult?.slice(0, 5).map((item: any, i: any) => {
                                        return (
                                          <MenuItem
                                            disableRipple
                                            key={i}
                                            onClick={() => globalSearchFromHistory(i, 0, pageSize)}
                                          >
                                            <HistoryIcon sx={{ mr: 1 }} /> {`${item.actual_value}`} -&nbsp;&nbsp;{' '}
                                            <span className="column_name"> {item.filter_column} </span>
                                          </MenuItem>
                                        );
                                      })}
                                  </MenuList>
                                </Popover>
                              )}
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="search-filter-iconbtn-wrap focused">
                      <IconButton
                        aria-label="Advance Search Filter"
                        id="filter-button"
                        aria-controls={open ? 'filter' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleClickFilter('bottom-end')}
                        tabIndex={2}
                        title="Show Advance Search Filters"
                      >
                        <Badge badgeContent={badgeCount} color="primary" className="small-badge">
                          <TuneIcon />
                        </Badge>
                      </IconButton>
                      <Popper
                        id="filter"
                        open={open3 || isEdit ? true : false}
                        anchorEl={anchorElFilter}
                        placement={placement}
                        transition
                        className="SearchFiltersPop"
                        onResize={undefined}
                        onResizeCapture={undefined}
                      >
                        {({ TransitionProps }) => (
                          <ClickAwayListener onClickAway={handleClickAway}>
                            <Fade {...TransitionProps} timeout={350}>
                              <Paper elevation={5}>
                                <Paper
                                  elevation={0}
                                  sx={{
                                    p: 1,
                                    pl: 3,
                                    pr: 3
                                  }}
                                >
                                  <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Grid>
                                      {isPreset && isPreset ? (
                                        <Typography variant="h6" component="div">
                                          <TextField
                                            id="standard-basic"
                                            label="Name of Preset"
                                            onChange={e => {
                                              setPresetName(e.target.value.trim());
                                              if (!e.target.value.trim()) {
                                                setIsPresetName(true);
                                                setIsEditStarted(false);
                                              } else {
                                                setIsPresetName(false);
                                                setIsEditStarted(true);
                                              }
                                            }}
                                            variant="standard"
                                            defaultValue={presetSearchData.preset_name}
                                            inputProps={{
                                              maxLength: 16
                                            }}
                                          ></TextField>
                                        </Typography>
                                      ) : (
                                        <Typography variant="h6" component="div">
                                          Filters
                                        </Typography>
                                      )}
                                    </Grid>
                                    <Grid>
                                      <Button size="small" sx={{ mr: -1 }} onClick={handleClear}>
                                        Clear
                                      </Button>
                                    </Grid>
                                  </Grid>
                                  <Box
                                    sx={{
                                      maxHeight: '53vh',
                                      overflowY: 'auto',
                                      overflowX: 'hidden',
                                      mr: '-8px',
                                      pr: '8px'
                                    }}
                                    className="scrollBox"
                                  >
                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p1Expand}
                                      onChange={() => setP1Expand(!p1Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                      >
                                        <Typography>Document Details</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={3} rowSpacing={1.5}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="Type"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setTypeVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={type}
                                                value={isPreset ? metaData.tmf_doc_type : typeVal}
                                                inputValue={inputTypeVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, tmf_doc_type: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, tmf_doc_type: newInputValue });
                                                    setInputTypeVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Type"
                                                    name="tmf_doc_type"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="Subtype"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setSubTypeVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={subType}
                                                value={isPreset ? metaData.tmf_doc_subtype : subTypeVal}
                                                inputValue={inputSubTypeVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, tmf_doc_subtype: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, tmf_doc_subtype: newInputValue });
                                                    setInputSubTypeVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Subtype"
                                                    name="tmf_doc_subtype"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="ArtifactName"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setArtifactNameVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={artifactName}
                                                value={isPreset ? metaData.tmf_artifact_name : artifactNameVal}
                                                inputValue={inputArtifactNameVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, tmf_artifact_name: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, tmf_artifact_name: newInputValue });
                                                    setInputArtifactNameVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Artifact Name"
                                                    name="tmf_artifact_name"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Document Status"
                                                name="tmf_doc_status"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_status : docStatusVal}
                                                value={isPreset ? metaData.tmf_doc_status : docStatusVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {docStatuses?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-basic"
                                                label="Document Name"
                                                name="tmf_document_name"
                                                defaultValue={isPreset ? metaData.tmf_document_name : docNameVal}
                                                inputRef={docNameInput}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                              ></TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-basic"
                                                label="Document Number"
                                                name="tmf_document_id"
                                                defaultValue={isPreset ? metaData.tmf_document_id : docIdVal}
                                                inputRef={docNoInput}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                              ></TextField>
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Filing Level"
                                                name="tmf_doc_level"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_level : docLevelVal}
                                                value={isPreset ? metaData.tmf_doc_level : docLevelVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {tmflevels?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Study"
                                                name="tmf_doc_study"
                                                onChange={e => {
                                                  setDocStudyVal(e.target.value);
                                                  setCurrentStudy(e.target.value);
                                                  isPreset && setIsEditStarted(true);
                                                }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_study : docStudyVal}
                                                value={isPreset ? metaData.tmf_doc_study : docStudyVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {studyList.map((item: string, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Country"
                                                name="tmf_doc_country"
                                                onChange={e => {
                                                  setCountryVal(e.target.value);
                                                  setCurrentCountry(e.target.value);
                                                  isPreset && setIsEditStarted(true);
                                                }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_country : countryVal}
                                                value={isPreset ? metaData.tmf_doc_country : countryVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {countryList.map((item: string, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Site"
                                                name="tmf_doc_site"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_site : siteVal}
                                                value={isPreset ? metaData.tmf_doc_site : siteVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {siteList?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>

                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p2Expand}
                                      onChange={() => setP2Expand(!p2Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel2a-header"
                                      >
                                        <Typography>Milestone Status</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={3}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Milestone"
                                                name="tmf_doc_milestone"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_milestone : milestoneVal}
                                                value={isPreset ? metaData.tmf_doc_milestone : milestoneVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {milestones?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Milestone Status"
                                                name="tmf_doc_milestone_status"
                                                onChange={handleAdvFieldChange}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_milestone_status : mileStatusVal
                                                }
                                                value={isPreset ? metaData.tmf_doc_milestone_status : mileStatusVal}
                                              >
                                                <MenuItem value=""></MenuItem>
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Department"
                                                name="tmf_doc_viewer_department"
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_viewer_department : departmentVal
                                                }
                                                value={departmentVal}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {departments?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Product"
                                                name="tmf_doc_viewer_product_detail"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_viewer_product_detail : productVal
                                                }
                                                value={productVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>

                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p3Expand}
                                      onChange={() => setP3Expand(!p3Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel3a-content"
                                        id="panel3a-header"
                                      >
                                        <Typography>Modification Details</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={4}>
                                          <Grid item md={6}>
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{ mb: 2, display: 'flex' }}
                                              className="custom-datePickerWrapper"
                                            >
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label="Uploaded From"
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(uploadedFromDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidUploadedFromDate(err, value)
                                                    }
                                                    onChange={(newValue: any) => {
                                                      setuploadedFromDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                    className="smalllabel"
                                                    minDate={new Date('2017-01-01')}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                              <Grid
                                                item
                                                md={2}
                                                sx={{
                                                  display: 'flex',
                                                  alignSelf: 'end',
                                                  lineHeight: 2,
                                                  justifyContent: 'center'
                                                }}
                                              >
                                                to
                                              </Grid>
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label=" "
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(uploadedToDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidUploadedToDate(err, value)
                                                    }
                                                    minDate={uploadedFromDate}
                                                    onChange={(newValue: any) => {
                                                      setuploadedToDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                          <Grid item md={6}>
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{ mb: 2, display: 'flex' }}
                                              className="custom-datePickerWrapper"
                                            >
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label="Last Modified"
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(modifiedFromDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidModifiedFromDate(err, value)
                                                    }
                                                    onChange={(newValue: any) => {
                                                      setmodifiedFromDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                    className="smalllabel"
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                              <Grid
                                                item
                                                md={2}
                                                sx={{
                                                  display: 'flex',
                                                  alignSelf: 'end',
                                                  lineHeight: 2,
                                                  justifyContent: 'center'
                                                }}
                                              >
                                                to
                                              </Grid>
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label=" "
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(modifiedToDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidModifiedToDate(err, value)
                                                    }
                                                    minDate={modifiedFromDate}
                                                    onChange={(newValue: any) => {
                                                      setmodifiedToDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid container direction="row" spacing={3}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Uploaded By"
                                                name="tmf_doc_created_by"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.tmf_doc_created_by : createdbyVal}
                                                value={createdbyVal}
                                                SelectProps={{
                                                  MenuProps: {
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                      style: {
                                                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                                        width: 250
                                                      }
                                                    }
                                                  }
                                                }}
                                              >
                                                {usersList?.length > 0 &&
                                                  usersList.map((user: any, index: number) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={user.firstName + ' ' + user.lastName}
                                                      sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                                                    >
                                                      {`${user.firstName}  ${user.lastName} (${user.email})`}
                                                    </MenuItem>
                                                  ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Modified By"
                                                name="tmf_doc_last_modified_by"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_last_modified_by : modifiedbyVal
                                                }
                                                value={modifiedbyVal}
                                                SelectProps={{
                                                  MenuProps: {
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                      style: {
                                                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                                        width: 250
                                                      }
                                                    }
                                                  }
                                                }}
                                              >
                                                {usersList?.length > 0 &&
                                                  usersList.map((user: any, index: number) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={user.firstName + ' ' + user.lastName}
                                                      sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                                                    >
                                                      {`${user.firstName}  ${user.lastName} (${user.email})`}
                                                    </MenuItem>
                                                  ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="QC Issue Type"
                                                name="tmf_doc_viewer_qc_issue_type"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_viewer_qc_issue_type : qcissueVal
                                                }
                                                value={qcissueVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {qcIssueTypes?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-basic"
                                                label="QC Issue Comments"
                                                name="tmf_doc_viewer_qc_issue_comments"
                                                defaultValue={
                                                  isPreset ? metaData.tmf_doc_viewer_qc_issue_comments : qccommentVal
                                                }
                                                inputRef={qcCommentsInput}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                value={qccommentVal}
                                              ></TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>
                                  </Box>
                                  <FormGroup sx={{ mt: 1 }}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={certifyRequired}
                                          onClick={cbxCertifyClick}
                                          name="tmf_doc_viewer_req_certified_copy"
                                        />
                                      }
                                      label="Require Certified Copy?"
                                    />
                                  </FormGroup>

                                  <Stack
                                    spacing={2}
                                    direction="row"
                                    sx={{ display: 'flex', justifyContent: 'flex-end', my: 1 }}
                                  >
                                    {isPreset && isPreset ? (
                                      <div>
                                        <Button onClick={() => cancelEditPresetFilter()}>Cancel</Button>
                                        <Button
                                          onClick={() => handleEditPresetFilter(0, pageSize)}
                                          disabled={!isEditStarted || isPresetName}
                                        >
                                          Save and Search
                                        </Button>
                                      </div>
                                    ) : (
                                      <>
                                        <Button onClick={handleSaveDialogBox}>Save Preset</Button>
                                        <Button onClick={() => advancedFilterSearch(0, pageSize)}>Search</Button>
                                        <PopupComponent
                                          open={enable}
                                          aria-labelledby="alert-dialog-title"
                                          aria-describedby="alert-dialog-description"
                                          className="savePresetDialog"
                                        >
                                          <DialogTitle id="alert-dialog-title">{'Save Preset'}</DialogTitle>
                                          <DialogContent>
                                            <DialogContentText id="alert-dialog-description"></DialogContentText>
                                            <Grid item md={12}>
                                              <FormControl fullWidth>
                                                <TextField
                                                  id="standard-basic"
                                                  label="Name of Preset"
                                                  onChange={e => handlePresetName(e)}
                                                  variant="standard"
                                                  inputProps={{
                                                    maxLength: 16
                                                  }}
                                                ></TextField>
                                              </FormControl>
                                            </Grid>
                                          </DialogContent>
                                          <DialogActions>
                                            <Button onClick={handleSaveClose} autoFocus>
                                              CANCEL
                                            </Button>
                                            <Button
                                              onClick={() => handleSavePresetFilter(true)}
                                              disabled={disablePresetSave}
                                            >
                                              SAVE
                                            </Button>
                                          </DialogActions>
                                        </PopupComponent>
                                      </>
                                    )}
                                  </Stack>
                                </Paper>
                              </Paper>
                            </Fade>
                          </ClickAwayListener>
                        )}
                      </Popper>
                    </div>
                  </Box>
                </Grid>
                <PopupComponent
                  open={openDeletePreset}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{`Delete Preset`}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {`Are you really want to delete the filter preset ?`}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDeletePreset}>No</Button>
                    <Button onClick={() => handleDeletePreset(true)} autoFocus>
                      Yes
                    </Button>
                  </DialogActions>
                </PopupComponent>
                <Grid item md={3} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                  <SearchPreset
                    isSave={isSave}
                    setPresetSearchData={setPresetSearchData}
                    presetName={presetName}
                    isClear={isClear}
                    handleClear={handleClear}
                    isPresetValue={isPreset}
                    metaData={metaData}
                    setShowResult={setShowResult}
                  />
                </Grid>
              </Grid>
              {showResult && (
                <Box className="resultBox">
                  <Typography variant="h6" component="div">
                    Results
                  </Typography>

                  <div style={{ height: '70vh', width: '100%' }}>
                    <DataGridPro
                      rows={searchResultRows}
                      columns={columns}
                      disableSelectionOnClick
                      pageSize={pageSize}
                      rowCount={rowCount}
                      page={page}
                      onPageChange={newPage => setPage(newPage)}
                      onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                      rowsPerPageOptions={[5, 10, 20]}
                      checkboxSelectionVisibleOnly={true}
                      pagination
                      paginationMode="server"
                      components={{
                        NoRowsOverlay: CustomNoRowsOverlay,
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterButtons,
                        Pagination: CustomPagination
                      }}
                      columnVisibilityModel={columnVisibilityModel}
                      onColumnVisibilityModelChange={(newModel: any) => {
                        setColumnVisibilityModel(newModel);
                      }}
                      className="SearchResult_DataGrid"
                      checkboxSelection
                      selectionModel={selectionModel}
                      onSelectionModelChange={onSelectionModelChange}
                    />
                  </div>
                </Box>
              )}
            </Box>
            {/* {openPopup && <DisclaimerPopup openPopup={openPopup} setOpenPopup={setOpenPopup} />} */}
          </>
        </div>
      ) : (
        <div>
          <DocumentViewerComponent
            documentDetails={documentToDisplaySearch}
            props={props}
            setDataGridComponent={setDataGridComponent}
            setOpenVersion={setOpenVersion}
            setEditedFmID={setEditedFmID}
          />
        </div>
      )}

      {/* -- for Send to ISF Dialog -- */}
      <PopupComponent open={openSend}>
        <Loader open={loaderStatus} />
        <DialogTitle>Send to ISF</DialogTitle>
        <DialogContent className="sendToDialog">
          <DialogContentText>The following documents already exist in ISF:</DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              {isfToBePublishedFiles.map((item: any) => {
                return (
                  <ListItem disablePadding key={item.id}>
                    <ListItemButton>
                      <ListItemText primary={item.tmf_document_name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>

          <FormControl>
            <RadioGroup
              aria-labelledby="sent to ISF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSendToISF} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleCloseSend} disabled={!checked}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(SearchComponent);
